import { RichText } from '@sunwebgroup/uds-ui/rich-text'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { isEmpty } from 'ramda'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createPDPClickEvent } from '@/scopes/products/infrastructure/analytics'
import { HeadingLabel } from '../HeadingLabel'
import { RoomType } from './RoomType'
import styles from './RoomTypes.module.css'
import ShowAllRoomTypes from './ShowAllRoomTypes'

const MAXIMUM_ROOM_TYPES_SHOWN = 4

export function RoomTypes() {
  const roomTypes = useCMSPageField('PDP.roomTypes')
  const additionalInfoHtml = useCMSPageField('PDP.roomTypes.additionalInfoHtml')
  const intl = useIntl()
  const { sendEvent } = useAnalytics()

  const handleShowAllRoomTypes = (isOpen: boolean) => {
    if (isOpen) {
      sendEvent(createPDPClickEvent({
        element: 'Accordion',
        description: 'Show more room types',
        result: `Show all ${roomTypes.length} roomtypes`,
      }))
    }
    else {
      sendEvent(createPDPClickEvent({
        element: 'Accordion',
        description: 'Show less room types',
        result: `Show less roomtypes`,
      }))
    }
  }

  return (
    <div className={styles.roomTypes}>
      <HeadingLabel text={intl.formatMessage({ id: 'roomtypes_heading' })} />
      <div className={styles.rooms}>
        {!isEmpty(roomTypes) && (
          roomTypes.slice(0, MAXIMUM_ROOM_TYPES_SHOWN).map(roomType => (
            <RoomType roomType={roomType} key={roomType.id} />
          ))
        )}
      </div>
      {roomTypes.length > MAXIMUM_ROOM_TYPES_SHOWN && <ShowAllRoomTypes onOpenChange={handleShowAllRoomTypes} />}
      {additionalInfoHtml?.trim() && (
        <div className={styles.additionalInfo}>
          <Typography variant="body-m-bold-tight">
            {intl.formatMessage({ id: 'roomtypes_extra_info_label' })}
          </Typography>
          <RichText innerHTML={additionalInfoHtml} />
        </div>
      )}
    </div>
  )
}
